/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Milliseconds as e}from"../../../core/time.js";const o={desiredScreenFlow:2,minDuration:e(500),maxDuration:e(8e3)},r={...o,maxDuration:e(4e3)};export{o as defaultSettings,r as defaultSettings2D};
